import client, { unwrap } from "./client"

// The languages this deployment serves, in picker order. Unauthenticated, so it is
// safe to call before login. See vantero-backend/docs/LANGUAGE_SUPPORT.md §4.
export async function fetchLanguages({ signal } = {}) {
  const response = await client.get("/languages/", { signal })
  return unwrap(response) ?? []
}
